export default "__VITE_ASSET__gZtWy18K__"